import React, { useEffect, useState } from "react";
import { LoadingIcon, EditLargeIcon } from "../../assets/icons/Icons";
import FormSection from "../form/Section";
import Switch from "../form/Switch";
import FormHeader from "../form/Header";
import Popup from "../Popup";
import { UpdateCorporateCustomer } from "../../api/corporate-customers/updateCorporateCustomer";
import { useTranslation } from "react-i18next";
import CountrySelect from "../form/CountrySelect";
import StateSelect from "../form/StateSelect";

const EditCorporateCustomer = ({
  corporateCustomer,
  onUpdate,
  onClose,
  ...props
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(true);

  const [status, setStatus] = useState(corporateCustomer.status ? "1" : "0");
  const [corporate_name, setcorporateName] = useState(
    corporateCustomer.corporate_name || ""
  );
  const [address1, setAddress1] = useState(corporateCustomer.address1 || "");
  const [address2, setAddress2] = useState(corporateCustomer.address2 || "");
  const [city, setCity] = useState(corporateCustomer.city || "");
  const [province, setProvince] = useState(corporateCustomer.state || "");
  const [postal_code, setPostalCode] = useState(
    corporateCustomer.postal_code || ""
  );
  const [country_code, setCountryCode] = useState(
    corporateCustomer.country_code || ""
  );
  const [error, setError] = useState("");

  const handleStatusChange = (e) => {
    if (e.target.checked) {
      setStatus("1");
    } else {
      setStatus("0");
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSubmitDisabled(true);
    try {
      await UpdateCorporateCustomer(corporateCustomer.id, {
        corporate_name,
        address1,
        address2,
        city,
        state: province,
        postal_code,
        country_code,
        status,
      });
      setLoading(false);
      setSubmitDisabled(false);
      onUpdate();
    } catch (err) {
      setError(err.message);
      setLoading(false);
      setSubmitDisabled(false);
      console.log("Error updating corporate customer: " + err);
    }
  };

  useEffect(() => {
    if (
      status !== corporateCustomer.status ||
      corporate_name !== (corporateCustomer.corporate_name || "") ||
      address1 !== (corporateCustomer.address1 || "") ||
      address2 !== (corporateCustomer.address2 || "") ||
      city !== (corporateCustomer.city || "") ||
      province !== (corporateCustomer.province || "") ||
      postal_code !== (corporateCustomer.postal_code || "") ||
      country_code !== (corporateCustomer.country_code || "")
    ) {
      setSubmitDisabled(false);
    } else {
      setSubmitDisabled(true);
    }
  }, [
    status,
    corporate_name,
    address1,
    address2,
    city,
    province,
    postal_code,
    country_code,
    corporateCustomer,
  ]);

  return (
    <Popup size="large" withClose withOverlay onClose={onClose}>
      <form method="post" onSubmit={handleSubmit}>
        <FormHeader
          title={t("Edit Corporate Customer")}
          description={t(
            "Edit existing corporate customer details or disable the customer account as needed."
          )}
          icon={<EditLargeIcon />}
        ></FormHeader>

        <div className="row mb-5 mt-5 align-items-center">
          <div className="col-xs-12">
            <Switch title={t("Enabled")}>
              <input
                type="checkbox"
                name="status"
                id="status"
                checked={status === "1"}
                onChange={handleStatusChange}
              />
            </Switch>
          </div>
        </div>

        <div className="row mb-5">
          <div className="col-xs-12">
            <FormSection title={t("Corporate Customer Name")} required>
              <input
                type="text"
                name="corporate_customer"
                id="corporate_customer"
                maxLength="100"
                placeholder={t("Corporate customer name")}
                value={corporate_name}
                onChange={(e) => setcorporateName(e.target.value)}
              />
            </FormSection>
          </div>
        </div>

        <div className="row mb-5">
          <div className="col-xs-6">
            <FormSection title={t("Address1")}>
              <input
                type="text"
                name="address1"
                id="address1"
                placeholder={t("Street address")}
                value={address1}
                onChange={(e) => setAddress1(e.target.value)}
              />
            </FormSection>
          </div>
          <div className="col-xs-6">
            <FormSection title={t("Address2")}>
              <input
                type="text"
                name="address2"
                id="address2"
                placeholder={t("Street address")}
                value={address2}
                onChange={(e) => setAddress2(e.target.value)}
              />
            </FormSection>
          </div>
        </div>

        <div className="row mb-5">
          <div className="col-xs-6">
            <FormSection title={t("City")}>
              <input
                type="text"
                name="city"
                id="city"
                placeholder={t("City")}
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
            </FormSection>
          </div>
          <div className="col-xs-6">
            <FormSection title={t("Province/State")}>
              <StateSelect
                value={province}
                onChange={(option) => setProvince(option.value)}
              />
            </FormSection>
          </div>
        </div>

        <div className="row mb-5">
          <div className="col-xs-6">
            <FormSection title={t("Postal Code")}>
              <input
                type="text"
                name="postal_code"
                id="postal_code"
                placeholder={t("Postal/ZIP code")}
                value={postal_code}
                onChange={(e) => setPostalCode(e.target.value)}
              />
            </FormSection>
          </div>
          <div className="col-xs-6">
            <FormSection title={t("Country")}>
              <CountrySelect
                onlyCountry={"Canada"}
                value={country_code}
                onChange={(option) => setCountryCode(option.value)}
              />
            </FormSection>
          </div>
        </div>

        <div className="text-right">
          <button
            className={`btn btn-primary btn-medium ${
              loading ? "btn-loading" : ""
            }`}
            type="submit"
            name="submit"
            disabled={submitDisabled}
          >
            {loading ? <LoadingIcon /> : ""}
            {t("Save")}
          </button>
        </div>
        {error && <p className="color-error text-center mt-3">{error}</p>}
      </form>
    </Popup>
  );
};

export default EditCorporateCustomer;
